import { render, staticRenderFns } from "./Comunicados.vue?vue&type=template&id=4e072248"
import script from "./Comunicados.vue?vue&type=script&lang=js"
export * from "./Comunicados.vue?vue&type=script&lang=js"
import style0 from "./Comunicados.vue?vue&type=style&index=0&id=4e072248&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports